<template>
  <base-dialog
    v-model="localValue"
    title="Remove Payment Method"
    :loading="loading"
    :show-footer="true"
    :show-cancel="true"
    :show-confirm="true"
    cancel-label="Cancel"
    confirm-label="Remove"
    confirm-button-class="base-dialog__negative-btn"
    @confirm="$emit('confirm')"
    @cancel="$emit('cancel')"
    persistent
  >
    <div class="remove-payment-dialog__content">
      <div class="remove-payment-dialog__confirmation">
        <p class="remove-payment-dialog__question">Are you sure you want to remove this payment method?</p>

        <div class="remove-payment-dialog__payment-info" v-if="paymentMethod">
          <div class="remove-payment-dialog__payment-details">
            <div class="remove-payment-dialog__card-icon">
              <img v-if="hasCardImage(paymentMethod.type)" :src="require(`@/assets/${paymentMethod.type.toLowerCase()}.png`)" height="24" width="36" class="remove-payment-dialog__card-brand-icon" />
              <q-icon v-else name="credit_card" color="terziary" size="24px" />
            </div>
            <div class="remove-payment-dialog__payment-text">
              <span class="remove-payment-dialog__payment-type">{{ paymentMethod.type | capitalize }}</span>
              <span class="remove-payment-dialog__payment-number">ending with {{ paymentMethod.last4_digit }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="paymentMethod && paymentMethod.is_default === 'true'" class="remove-payment-dialog__default-notice">
        <q-icon name="info" size="18px" color="terziary" class="remove-payment-dialog__info-icon" />
        <div class="remove-payment-dialog__notice-content">
          <span class="remove-payment-dialog__notice-title">Default Payment Method</span>
          <span class="remove-payment-dialog__notice-text">This is currently set as your default payment method.</span>
        </div>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog.vue';

export default {
  name: 'RemovePaymentMethodDialog',
  components: {
    BaseDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    paymentMethod: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    hasCardImage(type) {
      const supportedCards = ['visa', 'mastercard'];
      return supportedCards.includes(type.toLowerCase());
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.remove-payment-dialog {
  &__content {
    padding: 8px 0;
  }

  &__warning-box {
    display: flex;
    align-items: center;
    background-color: rgba(255, 0, 0, 0.04);
    padding: 16px;
    border-radius: 10px;
    border-left: 4px solid #f44336;
    margin-bottom: 24px;
    box-shadow: 0 2px 8px rgba(244, 67, 54, 0.1);
    transition: box-shadow 0.2s ease;
  }

  &__warning-icon {
    margin-right: 12px;
    flex-shrink: 0;
  }

  &__warning-text {
    @include mona-sans-font($size: 15px, $bolded: true, $color: var(--danger));
  }

  &__confirmation {
    margin-bottom: 24px;
  }

  &__question {
    @include inter-font($size: 15px, $color: var(--main-text-color));
    margin: 0 0 20px 0;
    line-height: 1.6;
  }

  &__payment-info {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 16px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  &__payment-details {
    display: flex;
    align-items: center;
  }

  &__card-icon {
    margin-right: 12px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 28px;
  }

  &__card-brand-icon {
    border-radius: 4px;
    object-fit: contain;
  }

  &__payment-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__payment-type {
    @include mona-sans-font($size: 16px, $bolded: true, $color: var(--main-text-color));
  }

  &__payment-number {
    @include inter-font($size: 14px, $color: var(--secondary-text-color));
  }

  &__default-notice {
    background-color: #f0f9ff;
    padding: 16px;
    border-radius: 10px;
    border-left: 3px solid #027be3;
    display: flex;
    align-items: flex-start;
    box-shadow: 0 2px 6px rgba(2, 123, 227, 0.1);
    transition: box-shadow 0.2s ease;
  }

  &__info-icon {
    margin-right: 12px;
    margin-top: 2px;
    flex-shrink: 0;
  }

  &__notice-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__notice-title {
    @include inter-font($size: 14px, $bolded: true, $color: #027be3);
  }

  &__notice-text {
    @include inter-font($size: 13px, $color: #455a64);
    line-height: 1.4;
  }
}
</style>
